import { Box } from "@mui/material";
import { marks } from "../../utils/CommonUtils/constants";
import SliderWithLabel from "../../components/sliderWithLabel/SliderWithLabel";
import CustomActionIcon from "../../components/customActionIcon/CustomActionIcon";
import CustomAudioRecorder from "../../components/CustomAudioRecorder/CustomAudioRecorder";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import CachedIcon from "@mui/icons-material/Cached";
import useTranslationSetup from "../../utils/useTranslationSetup";
import "./styles.css";
import { produceEventLog } from "../../utils/helper";
import { getUserProperties } from "../../utils/helper";
import useParamValues from "../../utils/useParamValues";

const AssessmentFooter = ({
  fontSize,
  setFontSize,
  isRecording,
  isStopped,
  audioBlob,
  showSlider,
  setDuration,
  onClickRetake,
  onClickAudioRecorder,
  onClickSave,
  isProcessing,
  currentStep,
}) => {
  const { t } = useTranslationSetup();
  const buttonText =
    !isRecording && audioBlob === null ? t("start") : t("stop");
  const userProperties = getUserProperties(useParamValues());

  return (
    <Box className="assessment-footer-divider">
      {showSlider && (
        <Box className="slider-with-label-wrapper">
          <SliderWithLabel
            min={5}
            max={10}
            defaultValue={fontSize}
            step={0.01}
            setSliderValue={setFontSize}
            label={t("text_size")}
            marks={marks(t)}
          />
        </Box>
      )}

      <Box className="action-icon-audio-recorder-container">
        {isStopped && audioBlob != null && (
          <Box
            className="custom-action-icon-wrapper"
            onClick={() => {
              onClickRetake();
              produceEventLog("assessment_retake1_button", {
                ...userProperties,
                assessment_flow: currentStep,
              });
            }}
          >
            <CustomActionIcon label={t("retake")}>
              <CachedIcon />
            </CustomActionIcon>
          </Box>
        )}
        <Box className="assessment-footer-audio-recorder-wrapper">
          <CustomAudioRecorder
            isRecording={isRecording}
            isStopped={isStopped}
            audioBlob={audioBlob}
            buttonText={buttonText}
            activity="assessment"
            setDuration={setDuration}
            onClick={onClickAudioRecorder}
            loading={isProcessing}
          />
        </Box>
        {isStopped && audioBlob != null && (
          <Box className="custom-action-icon-wrapper" onClick={onClickSave}>
            <CustomActionIcon label={t("save")}>
              <DoneOutlinedIcon />
            </CustomActionIcon>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AssessmentFooter;
